  <!-- top-ticker.component.html -->
  <div class="top-ticker">
    <div class="ticker-track" [style.animationDuration]="duration">
      <ng-container *ngFor="let m of messages">
        <span class="ticker-item">{{ m }}</span>
      </ng-container>
    </div>
  </div>
